import React, { useState } from 'react'
import { useMutation } from '@tanstack/react-query'
import { cn } from "@/lib/utils"
import { Button } from "@/components/ui/button"
import { supabase } from '@/supabaseClient'
import { Loader2 } from 'lucide-react'

export function LoginForm({
	className,
	...props
}: React.ComponentProps<"form">) {
	const [formError, setFormError] = useState<string | null>(null)

	const googleLoginMutation = useMutation({
		mutationFn: async () => {
			const { error } = await supabase.auth.signInWithOAuth({
				provider: 'google',
				options: {
					redirectTo: window.location.origin + '/runs',
				},
			})
			if (error) throw error
		},
		onError: (error) => {
			setFormError(error.message)
		}
	})

	const signInWithGoogle = (event: React.FormEvent) => {
		event.preventDefault()
		setFormError(null)
		googleLoginMutation.mutate()
	}

	return (
		<form className={cn("flex flex-col gap-6", className)} onSubmit={signInWithGoogle} {...props}>
			<div className="flex flex-col items-center gap-2 text-center">
				<h1 className="text-2xl font-bold">Login to your account</h1>
				<p className="text-muted-foreground text-sm text-balance">
					Continue with your Google account
				</p>
			</div>
			<div className="grid gap-6">
				{formError && <p className="text-red-500 text-sm">{formError}</p>}
				<Button type="submit" variant="outline" className="w-full" disabled={googleLoginMutation.isPending}>
					{googleLoginMutation.isPending && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
					Sign in with Google
				</Button>
			</div>
			<div className="text-center text-sm">
				Don&apos;t have an account?{" "}
				<a href="/signup" className="underline underline-offset-4">
					Sign up
				</a>
			</div>
		</form>
	)
}
